import { FC } from 'react';
import { Trans } from 'react-i18next';
import { last, startCase } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate } from '@fortawesome/free-solid-svg-icons';
import { Typography, Button, Divider } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import makeStyles from '@mui/styles/makeStyles';
import useGame from '@monorepo/shared/src/hooks/use-game';
import { tA11y } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import theme from '@monorepo/shared/src/themes/defaultTheme';
import {
  Maybe,
  SoundOutWordsPage,
  SoundOutWordsWord,
} from '@monorepo/shared/src/graph/schema-generated-types-educator';

const ActivityLastPage: FC = () => {
  const classes = useStyles();
  const [{ activityData }, { handleRestartActivity }] = useGame<SoundOutWordsPage>();
  const words = last<SoundOutWordsPage>(activityData?.pages)?.words;

  const deriveWordCase = (item: Maybe<SoundOutWordsWord>) =>
    item?.word.capitalize ? startCase(item.word.description) : item?.word.description;

  return (
    <div className={classes.lastPage}>
      <div className={classes.leftSection}>
        {words?.map((item, i) => (
          <Typography variant="h2" key={i}>
            {deriveWordCase(item)}
          </Typography>
        ))}
      </div>
      <Divider orientation="vertical" />
      <div className={classes.rightSection}>
        <FontAwesomeIcon icon={faCertificate} size={'3x'} color={theme.palette.secondary.dark} />

        <Typography variant="h5" style={{ margin: '2rem' }}>
          <Trans>
            {tA11y('activities.SoundOutWordsCongrats.text', {
              activityName: tA11y('activities.SoundOutWordsCongrats.activityName'),
              title: activityData?.book?.title,
            })}
          </Trans>
        </Typography>

        <Button
          variant="contained"
          startIcon={<ReplayIcon />}
          style={{ color: 'white', backgroundColor: theme.palette.secondary.dark }}
          onClick={() => handleRestartActivity()}
        >
          {tA11y('buttons.restart')}
        </Button>
      </div>
    </div>
  );
};

export default ActivityLastPage;

const useStyles = makeStyles((theme) => ({
  lastPage: {
    display: 'flex',
    height: '100%',
  },
  leftSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '30%',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    padding: `${theme.spacing(15)} ${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(4)}`,
  },
  rightSection: {
    flexDirection: 'column',
    width: '70%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
}));
